export const chart_configuration = {
  height: 80,
  width: 100
};

export const legend_configuration = {
  chart_legend_height: '100px'
};
